<div class="add-section-wrapper w-full flex flex-col items-start" [id]="sectionData.uuid">
  <div class="section-title w-full font-bold font-poppins">
    Section Title
  </div>
  <div *ngIf="sectionForm" class="w-full flex start items-center">
    <div class="w-full">
      <app-text-input [parentFormGroup]="sectionForm" class="resource-input" controlName="title"
                      placeholder="Section Title"
                      type="small"></app-text-input>

    </div>
    <div class="icon-wrapper flex justify-end">
      <app-icon (click)="moveSectionElementUp()"
                [class.cursor-pointer]="currentFormIndex>0"
                [svgIcon]="currentFormIndex>0?'up-arrow':'up-arrow-disabled'"
                class="up-arrow-disabled-icon"></app-icon>
      <app-icon (click)="moveSectionElementDown()"
                [class.cursor-pointer]="currentFormIndex+1 < totalSectionCount"
                [svgIcon]="currentFormIndex+1 < totalSectionCount?'down-arrow':'down-arrow-disabled'"
                class="down-arrow-disabled-icon"></app-icon>
      <app-icon (click)="deleteSection()" class="cursor-pointer delete-bold-icon" svgIcon="delete-bold"></app-icon>
    </div>
  </div>
  <div *ngFor="let content of sectionData.content; let contentIndex = index; trackBy: trackByContent" class="w-full">
    <div class="layout-section-wrapper w-full flex items-center">
      <div class="w-[80%]">
        <div class="layout-heading-section font-bold font-work-sans">
          Layout
        </div>
        <div class="layout-menu-wrapper">
          <div [matMenuTriggerFor]="menu" class="layout-menu cursor-pointer">
            <div *ngIf="getLayoutType(content) === layoutType['1']" class="menu-content font-work-sans">
              Full
            </div>
            <div *ngIf="getLayoutType(content) === layoutType['2']" class="font-work-sans">
              <div class="w-full flex justify-between "
              >
                <div class="text-center menu-content-half min-w-[48%]">
                  1/2
                </div>
                <div class="text-center menu-content-half min-w-[48%]">
                  1/2
                </div>
              </div>
            </div>
            <div *ngIf="getLayoutType(content) === layoutType['3']" class=" font-work-sans">
              <div class="w-full flex justify-between "
              >
                <div class="text-center menu-content-half min-w-[32%]">
                  1/3
                </div>
                <div class="text-center menu-content-half min-w-[32%]">
                  1/3
                </div>
                <div class="text-center menu-content-half min-w-[32%]">
                  1/3
                </div>
              </div>
            </div>
            <div *ngIf="getLayoutType(content) === layoutType['4']" class=" font-work-sans">
              <div class="w-full flex justify-between "
              >
                <div class="text-center menu-content-half min-w-[30%]">
                  1/3
                </div>
                <div class="text-center menu-content-half min-w-[68%]">
                  2/3
                </div>
              </div>
            </div>
            <div *ngIf="getLayoutType(content) === layoutType['5']" class=" font-work-sans">
              <div class="w-full flex justify-between "
              >
                <div class="text-center menu-content-half min-w-[68%]">
                  2/3
                </div>
                <div class="text-center menu-content-half min-w-[30%]">
                  1/3
                </div>
              </div>
            </div>
          </div>
          <mat-menu #menu="matMenu" class="layout-menu-section w-[20%]">
            <div (click)="toggleMenu(layoutType['1'],contentIndex)"
                 [ngClass]="getLayoutType(content) === layoutType['1'] ? 'layout-menu-item-selected'  : 'layout-menu-item'"
                 class="w-full ">
              <div
                [ngClass]="getLayoutType(content) === layoutType['1']? 'layout-menu-type-selected' :'layout-menu-type'"
                class="text-center cursor-pointer">
                Full
              </div>
            </div>
            <div (click)="toggleMenu(layoutType['2'],contentIndex)"
                 [ngClass]="getLayoutType(content) === layoutType['2']? 'layout-menu-item-selected'  : 'layout-menu-item'"
                 class="w-full flex justify-between"
                 mat-menu-item>
              <div
                [ngClass]="getLayoutType(content) === layoutType['2']? 'layout-menu-type-selected' :'layout-menu-type'"
                class="text-center min-w-[48%]">
                1/2
              </div>
              <div
                [ngClass]="getLayoutType(content) === layoutType['2']? 'layout-menu-type-selected' :'layout-menu-type'"
                class="text-center min-w-[48%]">
                1/2
              </div>
            </div>
            <div (click)="toggleMenu(layoutType['3'],contentIndex)"
                 [ngClass]="getLayoutType(content) === layoutType['3']? 'layout-menu-item-selected'  : 'layout-menu-item'"
                 class="w-full flex justify-between"
                 mat-menu-item>
              <div
                [ngClass]="getLayoutType(content) === layoutType['3']? 'layout-menu-type-selected' :'layout-menu-type'"
                class="text-center min-w-[31%]">
                1/3
              </div>
              <div
                [ngClass]="getLayoutType(content) === layoutType['3']? 'layout-menu-type-selected' :'layout-menu-type'"
                class="text-center min-w-[31%]">
                1/3
              </div>
              <div
                [ngClass]="getLayoutType(content) === layoutType['3']? 'layout-menu-type-selected' :'layout-menu-type'"
                class="text-center min-w-[31%]">
                1/3
              </div>
            </div>
            <div (click)="toggleMenu(layoutType['4'],contentIndex)"
                 [ngClass]="getLayoutType(content) === layoutType['4']? 'layout-menu-item-selected'  : 'layout-menu-item'"
                 class="w-full flex justify-between"
                 mat-menu-item>
              <div
                [ngClass]="getLayoutType(content) === layoutType['4']? 'layout-menu-type-selected' :'layout-menu-type'"
                class="text-center min-w-[25%]">
                1/3
              </div>
              <div
                [ngClass]="getLayoutType(content) === layoutType['4']? 'layout-menu-type-selected' :'layout-menu-type'"
                class="text-center min-w-[72%]">
                2/3
              </div>
            </div>
            <div (click)="toggleMenu(layoutType['5'],contentIndex)"
                 [ngClass]="getLayoutType(content) === layoutType['5']? 'layout-menu-item-selected'  : 'layout-menu-item'"
                 class="w-full flex justify-between"
                 mat-menu-item>
              <div
                [ngClass]="getLayoutType(content) === layoutType['5']? 'layout-menu-type-selected' :'layout-menu-type'"
                class="text-center min-w-[72%]">
                2/3
              </div>
              <div
                [ngClass]="getLayoutType(content) === layoutType['5']? 'layout-menu-type-selected' :'layout-menu-type'"
                class="text-center min-w-[25%]">
                1/3
              </div>
            </div>
          </mat-menu>
        </div>
      </div>
      <div class="icon-wrapper flex justify-end items-end">
        <app-icon (click)="moveContentElementUp(contentIndex)" [class.cursor-pointer]="contentIndex>0"
                  [svgIcon]="contentIndex>0?'up-arrow':'up-arrow-disabled'" class="up-arrow-disabled-icon"></app-icon>
        <app-icon (click)="moveContentElementDown(contentIndex)"
                  [class.cursor-pointer]="contentIndex+1 < sectionData.content.length"
                  [svgIcon]="contentIndex+1 < sectionData.content.length ? 'down-arrow' :'down-arrow-disabled'"
                  class="down-arrow-disabled-icon"></app-icon>
        <app-icon (click)="deleteContentElement(contentIndex)" class="cursor-pointer delete-bold-icon"
                  svgIcon="delete-bold"></app-icon>
      </div>
    </div>
    <div class="content-wrapper w-full">
      <app-add-content (layoutValuesChangeEmitter)="onLayoutValueChange($event)" *ngIf="content" [contentData]="content"
                       [sectionUuid]="sectionData.uuid"></app-add-content>
    </div>
  </div>

  <div class="add-content-wrapper flex justify-center w-full">
    <div (click)="addContentBlock()" class="cursor-pointer flex items-center">
      <app-icon class="add-section-icon" svgIcon="add-bold"></app-icon>
      <span class="ml-[0.8rem] add-content-label font-work-sans font-semibold">
                Add Content Block
      </span>
    </div>
  </div>
</div>
